import script from "./Chrome.vue?vue&type=script&setup=true&lang=ts"
export * from "./Chrome.vue?vue&type=script&setup=true&lang=ts"

import "./Chrome.vue?vue&type=style&index=0&id=1e262dfd&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e262dfd"]])

export default __exports__